import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconListingLight = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			x: 3.00003,
			y: 4,
			width: 18,
			height: 1.63636,
			rx: .818182,
			fill: "#C6CCDA"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 3.00006,
			y: 8.90918,
			width: 18,
			height: 1.63636,
			rx: .818182,
			fill: "#C6CCDA"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 3.00006,
			y: 13.8182,
			width: 18,
			height: 1.63636,
			rx: .818182,
			fill: "#C6CCDA"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 3.00006,
			y: 18.7274,
			width: 18,
			height: 1.63636,
			rx: .818182,
			fill: "#C6CCDA"
		})
	]
});
const ForwardRef = forwardRef(SvgIconListingLight);
export default ForwardRef;
